import React, { useEffect } from "react";
import { fetchQueueStats } from "../helpers/apiHelper";
import { QueueStatsResponse, Pipeline } from "../types/statusTypes";
import { useApiErrorHandler } from "../hooks/useApiErrorHandler";
import QueueVolumeCard from "../components/QueueVolumeView/QueueVolumeCard";
import Loading from "../components/Loading";
import ErrorView from "./ErrorView";

export default function QueueVolumeView() {
  const { loading, response, fetchData, error } = useApiErrorHandler<QueueStatsResponse>();

  useEffect(() => {
    fetchData(fetchQueueStats());
  }, [fetchData]);

  return (
    <div className="d-grid gap-5 p-5">
      {loading && <Loading />}
      {!loading && error && (
        <ErrorView
          hasHomeButton={true}
          message="Something went wrong while fetching queue volume stats!"
        />
      )}
      {!loading && !error && response
      && Object.entries(Pipeline)
        .map(([titleKey, title]) => (
          <QueueVolumeCard key={titleKey} title={title} stats={response[titleKey]} />))}
    </div>
  );
}
